import React from "react";
import { Box, Stack, Typography, Button, Drawer } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicDrawerComponent = () => {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Drawer
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          height={"300px"}
          language="js"
          value={
            "const [state, setState] = React.useState({\n" +
            "    top: false,\n" +
            "    left: false,\n" +
            "    bottom: false,\n" +
            "    right: false,\n" +
            "  });\n" +
            "\n" +
            "  const toggleDrawer = (anchor, open) => (event) => {\n" +
            "    if (\n" +
            '      event.type === "keydown" &&\n' +
            '      (event.key === "Tab" || event.key === "Shift")\n' +
            "    ) {\n" +
            "      return;\n" +
            "    }\n" +
            "    setState({ ...state, [anchor]: open });\n" +
            "  };\n\n\n\n" +
            '{["left", "right", "top", "bottom"].map((anchor) => (\n' +
            "            <React.Fragment key={anchor}>\n" +
            "              <Button onClick={toggleDrawer(anchor, true)} sx={{ mr: 2 }}>\n" +
            "                {anchor}\n" +
            "              </Button>\n" +
            "              <BasicDrawer\n" +
            "                anchor={anchor}\n" +
            "                open={state[anchor]}\n" +
            "                onClose={toggleDrawer(anchor, false)}\n" +
            "              />\n" +
            "            </React.Fragment>\n" +
            "          ))}"
          }
        >
          {["left", "right", "top", "bottom"].map((anchor) => (
            <React.Fragment key={anchor}>
              <Button onClick={toggleDrawer(anchor, true)} sx={{ mr: 2 }}>
                {anchor}
              </Button>
              <Drawer
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
              />
            </React.Fragment>
          ))}
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicDrawerComponent;
